import { FunctionalComponent, h } from '@stencil/core';
import { AppMedia } from './app.media';

interface AppTestimonial {
    Image: any;
    JobTitle: string;
    Name: string;
    Quote:string;
    Index: number;
}


export const AppTestimonial: FunctionalComponent<AppTestimonial> = ({ Image, JobTitle, Name, Quote, Index }) => {

    return (
        <li class="uk-width-5-6 uk-width-1-2@m uk-text-center uk-light">
            <div class={`uk-position-relative uk-padding uk-height-1-1 uk-flex uk-flex-column uk-background-testimonial-${Index % 2}`}>
                <span class="uk-position-bottom-right" uk-icon="icon:quote-right;ratio:5" style={{ 'opacity': '0.2' }}></span>
                <AppMedia className='uk-position-top-left uk-visible@s wsio-testimonial uk-height-1-1 uk-width-auto' size="(max-width: 638px) 20vw, (max-width: 958px) 10vw, 10vw" media={Image} />
                <p class="uk-position-relative uk-text-lead@s uk-margin-bottom uk-flex-1 uk-light">{Quote}</p>
                <h4 class="uk-position-relative uk-margin-remove wsio-darker-green">{Name}</h4>
                <div class="uk-position-relative uk-margin-remove">{JobTitle}</div>
            </div>
        </li>
    )
};